import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polyline
    {...props}
    points="10.84 32.69 19.77 47.92 47.89 47.93 48.08 23.11 30.65 7.53"
  />
);

export const AvatarArtworkElphaba = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.elphaba}
    renderShadow={renderShadow}
  >
    <g>
      <g>
        <path
          d="M15.43,37.25c-.79-.78-2.13-.8-3.15-1.31-.19-.1-.38-.21-.55-.34-.21-.16-.4-.35-.54-.57-.48-.77-.29-1.73-.44-2.61,0,0,4.1.47,4.97,1.87s-.3,2.97-.3,2.97Z"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.97,32.03c.73.21,1.78,1.04,1.99,1.72s.13,1.41-.1,2.08c-.13.39-.31.76-.41,1.16s-.42,1.05-.22,1.41c-.77-.2-1.33-.84-1.59-1.53s-.29-1.45-.31-2.18"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.4,27.31c-.32.63-.39,1.34-.38,2.03,0,.42.05.86.25,1.23.15.27.38.5.62.7.43.37.93.68,1.46.91.72.32,1.36.56,1.95,1.05.18.15,2,1.14,2,1.15-.02-.96.41-1.89.72-2.81s.49-1.97,0-2.82c-.12-.2-.27-.39-.44-.56"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.69,24.85c-.92-.61-1.43-1.71-1.28-2.75-.44.02-.78.34-1.07.65-.84.91-1.25,2.16-.99,3.32s1.23,2.17,2.48,2.45"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.72,36.99c.01.43.03.87.14,1.29s.32.83.67,1.12c.24.19.53.32.81.44.76.33,1.55.67,2.39.73l.87-.41s-2.31-2.71-2.85-3.01-2.04-.16-2.04-.16Z"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.11,33.9c-.45-.17-.88-.38-1.28-.64-.25-.16-.5-.35-.66-.59-.31-.47-.26-1.07-.16-1.61.06-.32.14-.65.39-.88"
          fill="none"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.91,37.95c-.63.64-1.4,1.15-2.25,1.49-.12.05-.26.11-.3.23-.04.13.07.25.18.35.26.24.53.47.79.71.08.07.16.14.27.16.11.01.21-.03.31-.08.52-.25,1.67-.75,1.9-1.31.16-.39-.79-1.65-.9-1.54Z"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.32,30.17c-.76-.62-1.3-1.48-1.4-2.42s.26-1.92,1.02-2.56c.63-.52,1.54-.87,1.77-1.62.53.75.82,1.7.92,2.59.04.34.04.69-.04,1.03-.11.48-.39.92-.69,1.33-.41.57-1.07,1.14-1.59,1.63Z"
          fill="#312c32"
          stroke="#140f12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M33.99,14.49s-.2,9.33-1.21,12.17c-.84,2.38-3,5.17-5.87,7.97-1.85,1.79-5.1,1.8-6.96.02-2.91-2.79-5.1-5.58-5.95-7.98-1.01-2.83-1.21-12.17-1.21-12.17-.09-1.73,5.54-7.28,5.54-7.28,2.14-1.22,8.13-1.64,10.27-.42,0,0,4.56,1.38,5.4,7.71v-.02Z"
        fill="#97d162"
      />
      <path
        d="M28.48,12.4c.93,4.03,5.47,3.91,5.11,9.17,2.39-3.6,1.29-7.86.08-10.02s-2.78-4.59-3.85-3.96c-.47.67-1.09,3.55-1.34,4.81Z"
        fill="#312c32"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.18,24.55c-4.79-2.11-2.65-12.81,3.41-16.96,3.6-2.46,11.32-2.06,12.01-.78.04.08-.13.49-.69,2.47-.27.94-.54,2.74-.84,2.75-8.84.37-14.13,4.44-13.89,12.53Z"
        fill="#312c32"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="18.61"
        cy="21.92"
        r="3.51"
        fill="none"
        stroke="#615547"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <circle
        cx="28.18"
        cy="21.92"
        r="3.51"
        fill="none"
        stroke="#615547"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M31.69,21.92c0-1.94-1.57-3.51-3.51-3.51-4.42,0-5.15,7.01-9.57,7.01-1.94,0-3.51-1.57-3.51-3.51"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.75"
      />
      <path
        d="M16.94,41.31c.18.37.36.76.47,1.14.09.3.13.59.23.89.16.46.45.9.54,1.35.07.34-.02.62-.2.66"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.99,40.85c-.18.82.03,1.72.56,2.37.32.4.74.7,1.09,1.07s.62.87.55,1.37"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.03,40.48c-.07.51.17,1.02.53,1.39s.83.6,1.3.8.96.37,1.4.63"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1,32.65c-.4.16-1.3.09-1.74.08-.37,0-1.12.04-1.47-.08-.46-.16-1.63-1.1-1.63-1.1,0,0,2.31-.82,3.09-.82s3.09.82,3.09.82c0,0-.95.94-1.35,1.1Z"
        fill="#577838"
      />
      <path
        d="M20.17,31.4c.16-.51,1.21-1.25,1.71-1.37.33-.08,1.02.15,1.36.17.06,0,.18,0,.24,0,.31-.02.94-.24,1.25-.17.52.12,1.64.84,1.81,1.37.03.09-.08.18-.08.18,0,0-1.24-.35-1.69-.4-.35-.04-.88.06-1.41.06-.5,0-1-.09-1.33-.06-.47.05-1.77.4-1.77.4,0,0-.11-.09-.08-.18Z"
        fill="#46612d"
      />
      <path
        d="M17.18,40.62c.4-.13.77-.34,1.17-.44s.88-.07,1.18.22c.34.34.33.88.38,1.36.07.78.36,1.54.82,2.18"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.87,40.77c-.37.44-.47,1.09-.25,1.63.16.4.48.73.55,1.16.04.27-.02.55-.13.8"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.34,40.33c.26,0,.48.19.6.42s.13.5.13.75-.02.52.02.77c.08.47.39.87.68,1.25"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {[
        [22.47, 25.23],
        [20.11, 26.87],
        [21.42, 25.71],
        [24.73, 25.23],
        [29.15, 26.71],
        [26.85, 26.55],
        [28.34, 27.03],
        [27.84, 26.19],
        [26.1, 25.87],
        [22.37, 26.03],
        [21.26, 26.37],
        [17.89, 26.38],
        [18.77, 27.03],
        [25.23, 26.2],
        [19.49, 26.39],
      ].map(([cx, cy], index) => (
        <circle key={index} cx={cx} cy={cy} r="0.16" fill="#8abf5a" />
      ))}
      <path
        d="M11.9,23.29s-.2-6.91,4.61-9.66,10.49-3.06,10.49-3.06"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.76,20.51s.89-6.65,6.32-8.82c4.47-1.79,10.83-2.41,10.83-2.41"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.39,14.76s2.65-4.21,6.9-5.23,9.89-1.44,9.89-1.44"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.65,9.27s4.45-1.82,6.61-1.98,7.34-.49,7.34-.49"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7,11.35s1.21,1.8,2.31,2.82c1.33,1.23,3.58,3.47,3.55,5.12"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.64,8.55s3.41,2.72,5.31,8.33"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.05,9.82s5.27,5.61,5.66,8.06"
        fill="none"
        stroke="#201b1f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.48,12.4c.93,4.03,5.47,3.91,5.11,9.17,2.39-3.6,1.29-7.86.08-10.02s-2.78-4.59-3.85-3.96c-.47.67-1.09,3.55-1.34,4.81Z"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.18,24.55c-4.79-2.11-2.65-12.81,3.41-16.96,3.6-2.46,11.32-2.06,12.01-.78.04.08-.13.49-.69,2.47-.27.94-.54,2.74-.84,2.75-8.84.37-14.13,4.44-13.89,12.53Z"
        fill="none"
        stroke="#140f12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </AvatarArtwork>
);

export default AvatarArtworkElphaba;
